import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; 
import { useTranslation } from "react-i18next";


const OnboardingSuccess = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to home page after 5 seconds
    const timer = setTimeout(() => {
      navigate('/stripe-onboarding');
    }, 5000);

    // Clean up the timer on component unmount
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="success-container">
      <div className="success-card">
        <h2 className="success-title">{t("stripe_success.onboarding_successful")}</h2>
        <p className="success-message">{t("stripe_success.proceed_to_view_details")}</p>
        <p className="success-redirect">{t("stripe_success.redirecting_to_details")}</p>
      </div>
    </div>
  );
};

export default OnboardingSuccess;
